import React from 'react';
import { useFormContext } from 'react-hook-form';
import { connect, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import ContentSections from 'components/base/ContentSections';
import { OnlyContinueButton } from 'components/base/BottomStepComponent';
import LevelGeneralSection from 'components/level/LevelGeneralSection';
import { createLevelStepOneValidate } from './CreateLevelValidate';


const CreateLevelStepOne = ({
  languages,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { getValues, setError, clearErrors } = useFormContext();

  const goToNextStep = () => {
    const isValid = createLevelStepOneValidate({
      getValues,
      setError,
      clearErrors,
    })

    if (isValid) {
      dispatch({
        type: 'levels/stepChange',
        payload: { isBack: false, step: 0, isValid: true },
      });
    };
  };

  const getTabs = (language) => {
    const tabs = [
      <LevelGeneralSection
        language={language}
      />,
    ];
    return tabs;
  };

  return (
    <>
      <ContentSections
        languageTabContent={{
          containers: languages?.map((item) => ({
            container: getTabs(item.code),
            key: item.code,
            title: item.sourceName,
          })),
        }}
        hidePreview
      />
      <OnlyContinueButton
        continueAction={goToNextStep}
      />
    </>
  );
}

const mapPropsToState = (state) => ({
  languages: state.language.allList,
})

export default connect(mapPropsToState)(CreateLevelStepOne);
